import { ChevronLeftIcon, ChevronRightIcon, TriangleDownIcon } from '@chakra-ui/icons'
import { Button, ListItem, Text, UnorderedList } from '@chakra-ui/react'

interface IPagination {
  postsPerPage: number
  totalPosts: number
  currentPage: number
  paginate: (pageNumber: number) => void
}

const Pagination = ({ postsPerPage, totalPosts, currentPage, paginate }: IPagination) => {
  const pageNumbers = []

  const totalPages = Math.ceil(totalPosts / postsPerPage) - 1

  console.log('totalPages', totalPages)

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i)
  }

  return (
    <UnorderedList listStyleType='none'>
      <ListItem display='inline-block'>
        <Button isDisabled paddingX='0.2rem' variant='ghost' colorScheme='secondary' rounded='none'>
          <ChevronLeftIcon transform='scale(2.3)' />
        </Button>
      </ListItem>
      {pageNumbers.map((number) => (
        <ListItem display='inline-block' key={number}>
          <Button
            colorScheme='secondary'
            variant={currentPage === number ? 'solid' : 'outline'}
            margin='0.5'
            rounded='none'
            onClick={() => paginate(number)}
          >
            {number}
          </Button>
        </ListItem>
      ))}
      <ListItem display='inline-block'>
        <Button paddingX='0.2rem' variant='ghost' colorScheme='secondary' rounded='none'>
          <ChevronRightIcon transform='scale(2.3)' />
        </Button>
      </ListItem>
    </UnorderedList>
  )
}

export { Pagination }
